import { SessionStorageKey } from "@/constants/sessionStorage";

/**
 * Store traffic source ID in session storage
 * @param trafficSourceId 流入経路ID
 */
export const setTrafficSourceIdForSessionStorage = (trafficSourceId: string | null) => {
  if (trafficSourceId && trafficSourceId.length === 32) {
    // 32桁 = md5の文字列長
    sessionStorage.setItem(SessionStorageKey.TRAFFIC_SOURCE_ID, trafficSourceId);
  }
};

/**
 * Get traffic source ID from session storage
 */
export const getTrafficSourceIdForSessionStorage = (): string | null => {
  return sessionStorage.getItem(SessionStorageKey.TRAFFIC_SOURCE_ID) ?? null;
};
